define('presentation/settings/webChats/facades/addWebChatWidgetFacade',[
    'common/storage/commonState',
    'externalDependencies/clientWebSocket',
    'presentation/settings/webChats/presentationObjects/webChatWidgetPresentationObject',
    'presentation/settings/webChats/presentationObjects/webChatWidgetDomainPresentationObject'
], function () {
    const WebChatWidgetPresentationObjectConstructor = require('presentation/settings/webChats/presentationObjects/webChatWidgetPresentationObject');
    const WebChatWidgetDomainPresentationObjectConstructor = require('presentation/settings/webChats/presentationObjects/webChatWidgetDomainPresentationObject');

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const webChatSocket = clientWebSocket.forApplication("webChatWidget");
    const liveReceptionistScriptSocket = clientWebSocket.forApplication("liveReceptionistScript");

    const _commonState = require('common/storage/commonState');

    let _promiseFactory = null;

    const _buildWebChatDomainPresentationObject = (domain) => {
        const authorizedDomainPresentationObject = new  WebChatWidgetDomainPresentationObjectConstructor();
        authorizedDomainPresentationObject.webChatWidgetAuthorizedDomainId = domain.webChatWidgetAuthorizedDomainId;
        authorizedDomainPresentationObject.domain = domain.domain;
        return authorizedDomainPresentationObject;
    };

    const _buildWebChatWidgetPresentationObject = (widget) => {
        const webChatWidgetPresentationObject = new  WebChatWidgetPresentationObjectConstructor();
        webChatWidgetPresentationObject.webChatWidgetId = widget.webChatWidgetId;
        webChatWidgetPresentationObject.displayName = widget.displayName;
        webChatWidgetPresentationObject.launcherTextColor = widget.launcherTextColor;
        webChatWidgetPresentationObject.launcherBackgroundColor = widget.launcherBackgroundColor;
        webChatWidgetPresentationObject.welcomeMessage = widget.welcomeMessage;
        webChatWidgetPresentationObject.liveReceptionistScriptId = widget.liveReceptionistScriptId;
        webChatWidgetPresentationObject.authorizedDomains = widget.authorizedDomains.map(_buildWebChatDomainPresentationObject);
        return webChatWidgetPresentationObject;
    };

    const _getLiveReceptionistScripts = () => {
        return _promiseFactory.defer((promise) => {
            liveReceptionistScriptSocket.send("retrieveAll", {}, (liveReceptionistScripts) => {
                const scripts = liveReceptionistScripts.map((liveReceptionistScript) => {
                    const { liveReceptionistScriptId, name, status, type } = liveReceptionistScript;
                    return {
                        id: liveReceptionistScriptId,
                        name: name,
                        status: status,
                        scriptType: type,
                        type: _commonState.types.liveReceptionistScript
                    };
                });
                promise.resolve(scripts);
            });
        });
    };

    const _getWebChatWidget = (webChatWidgetId) => {
        return _promiseFactory.defer((promise) => {
            webChatSocket.send('getWebChatWidget', { webChatWidgetId }, response => {
                const webChatWidgetPresentationObject = _buildWebChatWidgetPresentationObject(response);
                promise.resolve(webChatWidgetPresentationObject);
            });
        });
    };

    const _createWebChatWidget = (newWebChatWidget) => {
        return _promiseFactory.defer((promise) => {
            const newWidgetRequest = {
                webChatWidgetId: newWebChatWidget.webChatWidgetId,
                displayName: newWebChatWidget.displayName,
                launcherTextColor: newWebChatWidget.launcherTextColor,
                launcherBackgroundColor: newWebChatWidget.launcherBackgroundColor,
                welcomeMessage: newWebChatWidget.welcomeMessage,
                liveReceptionistScriptId: newWebChatWidget.liveReceptionistScriptId,
                authorizedDomains: newWebChatWidget.authorizedDomains
            };
            webChatSocket.send('createWebChatWidget', newWidgetRequest, response => {
                const webChatWidgetPresentationObject = _buildWebChatWidgetPresentationObject(response);
                promise.resolve(webChatWidgetPresentationObject);
            });
        });
    };

    const _updateWebChatWidget = (updatedWebChatWidget) => {
        return _promiseFactory.defer((promise) => {
            const updateWidgetRequest = {
                webChatWidgetId: updatedWebChatWidget.webChatWidgetId,
                displayName: updatedWebChatWidget.displayName,
                launcherTextColor: updatedWebChatWidget.launcherTextColor,
                launcherBackgroundColor: updatedWebChatWidget.launcherBackgroundColor,
                welcomeMessage: updatedWebChatWidget.welcomeMessage,
                liveReceptionistScriptId: updatedWebChatWidget.liveReceptionistScriptId,
                authorizedDomains: updatedWebChatWidget.authorizedDomains
            };
            webChatSocket.send('updateWebChatWidget', updateWidgetRequest, response => {
                const webChatWidgetPresentationObject = _buildWebChatWidgetPresentationObject(response);
                promise.resolve(webChatWidgetPresentationObject);
            });
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function () {
        const self = this;
        self.init = _init;
        self.createWebChatWidget = _createWebChatWidget;
        self.getLiveReceptionistScripts = _getLiveReceptionistScripts;
        self.getWebChatWidget = _getWebChatWidget;
        self.updateWebChatWidget = _updateWebChatWidget;
    };
});

